export default "__VITE_ASSET__CK0Cjiqx__"